module.exports = __webpack_public_path__ + "images/stickers/taco-robot.c695266748c83f796b9a.png";